const assetSubType = {
  "NORMAL": "通常電柱",
  "WITH_PLANTS": "ツルツタ電柱",
  "HAS_PROTECTIVE_TUBE": "防護管付き電柱",
  "TELEGRAPH_CONCRETE_POLE": "電信柱（コンクリート柱）　",
  "TELEGRAPH_CONCRETE_POLE_HAS_SUPPORT_POLE": "電信柱（コンクリート柱・支柱あり）",
  "TELEGRAPH_STEEL_PIPE_POLE": "電信柱（鋼管柱）",
  "TELEGRAPH_STEEL_PIPE_POLE_HAS_SUPPORT_POLE": "電信柱（鋼管柱・支柱あり）",
  "TELEGRAPH_CONCRETE_LUCKY_POLE": "ラッキー電信柱（コンクリート柱）",
  "TELEGRAPH_CONCRETE_POLE_HAS_SUPPORT_LUCKY_POLE": "ラッキー電信柱（コンクリート柱・支柱あり）",
  "TELEGRAPH_STEEL_PIPE_LUCKY_POLE": "ラッキー電信柱（鋼管柱）",
  "TELEGRAPH_STEEL_PIPE_POLE_HAS_SUPPORT_LUCKY_POLE": "ラッキー電信柱（鋼管柱・支柱あり）",
  "JOINT_USE_POLE": "共架柱",
  "JOINT_USE_LUCKY_POLE": "ラッキー共架柱",
  "JOINT_USE_POLE_HAS_SUPPORT_POLE": "共架柱（支柱あり）",
  "JOINT_USE_POLE_HAS_SUPPORT_LUCKY_POLE": "ラッキー共架柱（支柱あり）",
  "LUCKY_MAN_HOLE": "ラッキーマンホール",
  "LUCKY_HAND_HOLE": "ラッキーハンドホール",
};

const assetSubTypeNtt = {
  "TELEGRAPH_CONCRETE_POLE": "電信柱（コンクリート柱）　",
  "TELEGRAPH_CONCRETE_POLE_HAS_SUPPORT_POLE": "電信柱（コンクリート柱・支柱あり）",
  "TELEGRAPH_STEEL_PIPE_POLE": "電信柱（鋼管柱）",
  "TELEGRAPH_STEEL_PIPE_POLE_HAS_SUPPORT_POLE": "電信柱（鋼管柱・支柱あり）",
  "TELEGRAPH_CONCRETE_LUCKY_POLE": "ラッキー電信柱（コンクリート柱）",
  "TELEGRAPH_CONCRETE_POLE_HAS_SUPPORT_LUCKY_POLE": "ラッキー電信柱（コンクリート柱・支柱あり）",
  "TELEGRAPH_STEEL_PIPE_LUCKY_POLE": "ラッキー電信柱（鋼管柱）",
  "TELEGRAPH_STEEL_PIPE_POLE_HAS_SUPPORT_LUCKY_POLE": "ラッキー電信柱（鋼管柱・支柱あり）",
  "JOINT_USE_POLE": "共架柱",
  "JOINT_USE_LUCKY_POLE": "ラッキー共架柱",
  "JOINT_USE_POLE_HAS_SUPPORT_POLE": "共架柱（支柱あり）",
  "JOINT_USE_POLE_HAS_SUPPORT_LUCKY_POLE": "ラッキー共架柱（支柱あり）",
  "LUCKY_MAN_HOLE": "ラッキーマンホール",
  "LUCKY_HAND_HOLE": "ラッキーハンドホール",
};

// TEPCO order
const reportTagSortTepco = [
  "ツルツタ1",
  "ツルツタ2",
  "ツルツタ3",
  "樹木",
  "営巣",
  "飛来物",
  "電垂れ",
  "電柱地際陥没",
  "電柱段差",
  "落書き",
  "錆",
  "その他",
  "番札",
  "番号",
  "換気孔破損",
  "換気孔段差",
  "撮影危険",
  "撮影困難",
  "位置ズレ",
  "対象無し",
  "電柱銘板",
  "電柱足場ボルト受口",
];

export default {
  assetSubType,
  assetSubTypeNtt,
  reportTagSortTepco,
}